module.exports = __webpack_public_path__ + "static/media/iphone 12 banner4.a0f7a37d.jpg";